export default __webpack_public_path__ + "static/media/partners.e5adcb0b.png";